import { render, staticRenderFns } from "./adminCSGList.vue?vue&type=template&id=4c610a34&scoped=true"
import script from "./adminCSGList.vue?vue&type=script&lang=js"
export * from "./adminCSGList.vue?vue&type=script&lang=js"
import style0 from "./adminCSGList.vue?vue&type=style&index=0&id=4c610a34&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c610a34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c610a34')) {
      api.createRecord('4c610a34', component.options)
    } else {
      api.reload('4c610a34', component.options)
    }
    module.hot.accept("./adminCSGList.vue?vue&type=template&id=4c610a34&scoped=true", function () {
      api.rerender('4c610a34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/user/csgAdminRole/adminCSGList.vue"
export default component.exports